<span class="d-flex-row">
  <ng-container #fieldComponent></ng-container><mat-icon [matTooltip]="props?.tooltip" matTooltipPosition="right">{{props.icon?props.icon:'info_outline'}}</mat-icon>
</span>
